var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 109,
    viewBox: "0 0 168 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.473633,
    y: 0.320435,
    width: 167.297,
    height: 107.826,
    rx: 53.913,
    fill: "#226FE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6223 54.2335L60.9973 58.8585C55.8886 63.9671 55.8886 72.2499 60.9973 77.3585C66.1059 82.4672 74.3886 82.4672 79.4973 77.3585L84.1223 72.7335M84.1223 35.7335L88.7473 31.1085C93.8559 25.9998 102.139 25.9998 107.247 31.1085C112.356 36.2171 112.356 44.4998 107.247 49.6085L102.622 54.2335M74.8729 63.4841L93.373 44.9841",
    stroke: "white",
    strokeWidth: 6.11385,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.789a13ec4dd85f3ce86c49f0465d10ac.svg";
export { ForwardRef as ReactComponent };